import React, {useEffect, useState} from "react";
import {Form, Row, Col, FloatingLabel, Button, Modal} from "react-bootstrap";
import axios from "axios";
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import "react-datepicker/dist/react-datepicker.css";
import GLOBALVAR from "../../constants";
import LoadingSpinner from "../../components/misc/LoadingSpinner";

function EditApplicant({applicantdb, updateParentApplicant}) {
    const [showSpinner, setShowSpinner] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false); // Add isSubmitting state
    const [applicant, setApplicant] = useState(applicantdb);
    const [showModal, setShowModal] = useState(false);
    const [modalHeader, setModalHeader] = useState(null);
    const [modalBody, setModalBody] = useState(null);
    const [errMessages, setErrMessages] = useState(false);
    const [birthday, setBirthday] = useState(applicantdb?.birthday ? new Date(applicantdb.birthday) : null);
    
    // Remove unused states
    // const [civilStatus, setCivilStatus] = useState("");
    const [isMarried, setIsMarried] = useState(false);

    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    // Update civil status handler to use formData
    const handleCivilStatusChange = (e) => {
        const value = e.target.value;
        setIsMarried(value === "Married");
        handleChange(e);
    };

    const handleBirthdayChange = (date) => {
        setBirthday(date);
        const formattedDate = date ? format(date, 'MM/dd/yyyy') : ''; 
        handleChange({ target: { name: "birthday", value: formattedDate } });
    };

    const [formData, setFormData] = useState({
        lastName: applicant?.lastName || '',
        firstName: applicant?.firstName || '',
        middleName: applicant?.middleName || '',
        mothersMaidenName: applicant?.mothersMaidenName || '',
        street: applicant?.street || '',
        barangay: applicant?.barangay || '',
        municipality: applicant?.municipality || '',
        province: applicant?.province || '',
        zipCode: applicant?.zipCode || '',
        birthday: applicant?.birthday ? format(new Date(applicant.birthday), 'MM/dd/yyyy') : '',
        gender: applicant?.gender || '',
        civilStatus: applicant?.civilStatus || '',
        marriedTo: applicant?.marriedTo || '',
        telephoneNo: applicant?.telephoneNo || '',
        mobileNo1: applicant?.mobileNo1 || '',
        mobileNo2: applicant?.mobileNo2 || '',
        emailAddress: applicant?.emailAddress || '',
        sssOrGsis: applicant?.sssOrGsis || '',
        passport: applicant?.passport || '',
        employerDetails: applicant?.employerDetails || '',
        employerAddress: applicant?.employerAddress || '',
        employerContactNumber: applicant?.employerContactNumber || '',
        employerLocation: applicant?.employerLocation || ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true); // Set submitting state
        setShowSpinner(true);

        try {
            const response = await axios.post(
                `${GLOBALVAR['SERVER_ROOT']}/api/applications/update/${applicant?.id}`, 
                formData
            );
            setModalHeader('Success');
            setModalBody(response.data.message);
            handleShow();
            setApplicant(response.data.application);
            updateParentApplicant(response.data.application);
        } catch (error) {
            console.error('Error submitting form:', error);
            setModalHeader('Validation Error');
            const errorsArray = error.response.data.error.split(',\n');
            const filteredErrors = errorsArray.filter(error => error.trim() !== '');
            setErrMessages(filteredErrors);
            handleShow();
        } finally {
            setIsSubmitting(false); // Reset submitting state
            setShowSpinner(false);
        }
    };

    useEffect(() => {
        console.log(formData);
    },[formData]);

    return (
        <>
            {showSpinner && (<LoadingSpinner />)}
            <Modal 
                show={showModal} 
                onHide={handleClose}
                size="lg"
                centered
                className="custom-modal"
            >
                <Modal.Header closeButton className="bg-light">
                    <Modal.Title>{modalHeader}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {errMessages ? (
                        <div className="alert alert-danger">
                            <ul className="mb-0">
                                {errMessages.map((error, index) => (
                                    <li key={index}>{error.trim().replace('Validation error: ', '')}</li>
                                ))}
                            </ul>
                        </div>
                    ) : (
                        <div className="alert alert-success">{modalBody}</div>
                    )}
                </Modal.Body>
            </Modal>

            <Form onSubmit={handleSubmit} className="edit-applicant-form">
                {/* Personal Information Section */}
                <div className="form-section">
                    <h5 className="section-title">Personal Information</h5>
                    <Row className="mb-3">
                        <Col md={4}>
                            <FloatingLabel controlId="floatingLastName" label="Last Name *">
                                <Form.Control 
                                    type="text" 
                                    name="lastName" 
                                    placeholder="Last Name"
                                    defaultValue={applicant?.lastName}
                                    onChange={handleChange}
                                    required 
                                />
                            </FloatingLabel>
                        </Col>
                        <Col md={4}>
                            <FloatingLabel controlId="floatingFirstName" label="First Name *">
                                <Form.Control 
                                    type="text" 
                                    name="firstName" 
                                    placeholder="First Name"
                                    defaultValue={applicant?.firstName}
                                    onChange={handleChange}
                                    required 
                                />
                            </FloatingLabel>
                        </Col>
                        <Col md={4}>
                            <FloatingLabel controlId="floatingMiddleName" label="Middle Name">  {/* Removed asterisk */}
                                <Form.Control 
                                    type="text" 
                                    name="middleName" 
                                    placeholder="Middle Name"
                                    defaultValue={applicant?.middleName}
                                    onChange={handleChange}
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={4}>
                            <FloatingLabel controlId="floatingMothersMaidenName" label="Mother's Maiden Name *">
                                <Form.Control 
                                    type="text" 
                                    name="mothersMaidenName" 
                                    placeholder="Mother's Maiden Name"
                                    defaultValue={applicant?.mothersMaidenName}
                                    onChange={handleChange}
                                    required 
                                />
                            </FloatingLabel>
                        </Col>
                        <Col md={4}>
                            <FloatingLabel 
                                controlId="floatingBirthday" 
                                label={applicant?.birthday ? '' : 'Birthday *'}
                            >
                                <DatePicker
                                    className="form-control"
                                    selected={birthday || (applicant?.birthday ? new Date(applicant.birthday) : null)}
                                    onChange={handleBirthdayChange}
                                    dateFormat="MM/dd/yyyy"
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    maxDate={new Date()}
                                    required
                                    placeholderText={applicant?.birthday ? '' : 'Select birthday'}
                                    popperClassName="datepicker-popper"
                                    popperPlacement="bottom-start"
                                    popperModifiers={[
                                        {
                                            name: 'preventOverflow',
                                            enabled: true,
                                            options: {
                                                altAxis: true,
                                                padding: 8
                                            }
                                        }
                                    ]}
                                    portalId="datepicker-portal"
                                />
                            </FloatingLabel>
                        </Col>
                        <Col md={4}>
                            <FloatingLabel controlId="floatingGender" label="Gender *">
                                <Form.Select 
                                    name="gender" 
                                    onChange={handleChange}
                                    defaultValue={applicant?.gender || ""}
                                    required
                                >
                                    <option value="">Select Gender</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={4}>
                            <FloatingLabel controlId="floatingCivilStatus" label="Civil Status *">
                                <Form.Select 
                                    name="civilStatus" 
                                    onChange={handleCivilStatusChange}
                                    defaultValue={applicant?.civilStatus || ""}
                                    required
                                >
                                    <option value="">Select Civil Status</option>
                                    <option value="Single">Single</option>
                                    <option value="Married">Married</option>
                                    <option value="Widowed">Widowed</option>
                                    <option value="Separated">Separated</option>
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                    </Row>
                </div>

                {/* Contact Information Section */}
                <div className="form-section">
                    <h5 className="section-title">Contact Information</h5>
                    <Row className="mb-3">
                        <Col md={6}>
                            <FloatingLabel controlId="floatingMobileNo1" label="Mobile No. 1 *">
                                <Form.Control 
                                    type="text" 
                                    name="mobileNo1"
                                    placeholder="Mobile No. 1"
                                    defaultValue={applicant?.mobileNo1}
                                    onChange={handleChange}
                                    required
                                />
                            </FloatingLabel>
                        </Col>
                        <Col md={6}>
                            <FloatingLabel controlId="floatingMobileNo2" label="Mobile No. 2">  {/* Removed asterisk */}
                                <Form.Control 
                                    type="text" 
                                    name="mobileNo2"
                                    placeholder="Mobile No. 2"
                                    defaultValue={applicant?.mobileNo2}
                                    onChange={handleChange}
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingEmailAddress" label="E-Mail Address *">
                                <Form.Control 
                                    type="email" 
                                    name="emailAddress"
                                    placeholder="E-Mail Address"
                                    defaultValue={applicant?.emailAddress}
                                    onChange={handleChange}
                                    required
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>
                </div>

                {/* Address Section */}
                <div className="form-section">
                    <h5 className="section-title">Address Information</h5>
                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingStreet" label={applicant?applicant.street:"House No. / Street"}>
                                <Form.Control type="text" name="street" placeholder="House No. / Street" onChange={handleChange} />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingBarangay" label={applicant?applicant.barangay:"Barangay"}>
                                <Form.Control type="text" name="barangay" placeholder="Barangay" onChange={handleChange} />
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingMunicipality" label={applicant?applicant.municipality:"Municipality/City"}>
                                <Form.Control type="text" name="municipality" placeholder="Municipality/City" onChange={handleChange} />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingProvince" label={applicant?applicant.province:"Province"}>
                                <Form.Control type="text" name="province" placeholder="Province" onChange={handleChange} />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingZipCode" label={applicant?applicant.zipCode:"Zip Code"}>
                                <Form.Control type="text" name="zipCode" placeholder="Zip Code" onChange={handleChange} />
                            </FloatingLabel>
                        </Col>
                    </Row>
                </div>

                {/* Additional Information Section */}
                <div className="form-section">
                    <h5 className="section-title">Additional Information</h5>
                    {isMarried && (
                        <Row className="mb-3">
                            <Col>
                                <FloatingLabel controlId="floatingMarriedTo" label="Married To *">
                                    <Form.Control 
                                        type="text" 
                                        name="marriedTo"
                                        placeholder="Married To"
                                        defaultValue={applicant?.marriedTo}
                                        onChange={handleChange}
                                        required
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col>
                                <FloatingLabel controlId="floatingTelephoneNo" label="Telephone No. *">
                                    <Form.Control 
                                        type="text" 
                                        name="telephoneNo"
                                        placeholder="Telephone No."
                                        defaultValue={applicant?.telephoneNo}
                                        onChange={handleChange}
                                        required
                                    />
                                </FloatingLabel>
                            </Col>
                        </Row>
                    )}
                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingSSSOrGSIS" label="SSS/GSIS #">  {/* Removed asterisk */}
                                <Form.Control 
                                    type="text" 
                                    name="sssOrGsis"
                                    placeholder="SSS/GSIS #"
                                    defaultValue={applicant?.sssOrGsis}
                                    onChange={handleChange}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingPassport" label="Passport #">  {/* Removed asterisk */}
                                <Form.Control 
                                    type="text" 
                                    name="passport"
                                    placeholder="Passport #"
                                    defaultValue={applicant?.passport}
                                    onChange={handleChange}
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>
                </div>

                {/* Employment Information Section */}
                <div className="form-section">
                    <h5 className="section-title">Employment Information</h5>
                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingEmployerDetails" label="Employer Name">  {/* Removed asterisk */}
                                <Form.Control 
                                    type="text" 
                                    name="employerDetails"
                                    placeholder="Employer Name"
                                    defaultValue={applicant?.employerDetails}
                                    onChange={handleChange}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingEmployerAddress" label="Employer Address">  {/* Removed asterisk */}
                                <Form.Control 
                                    type="text" 
                                    name="employerAddress"
                                    placeholder="Employer Address"
                                    defaultValue={applicant?.employerAddress}
                                    onChange={handleChange}
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingEmployerContactNumber" label="Employer Contact Number">
                                <Form.Control 
                                    type="text" 
                                    name="employerContactNumber"
                                    placeholder="Employer Contact Number"
                                    defaultValue={applicant?.employerContactNumber}
                                    onChange={handleChange}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingEmployerLocation" label="Job Position">
                                <Form.Control 
                                    type="text" 
                                    name="employerLocation"
                                    placeholder="Job Position"
                                    defaultValue={applicant?.employerLocation}
                                    onChange={handleChange}
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>
                </div>

                <div className="form-actions">
                    <Button 
                        variant="primary" 
                        type="submit" 
                        className="submit-btn"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Updating...' : 'Update Details'}
                    </Button>
                </div>
            </Form>
        </>
    );
}

export default EditApplicant